// ✅ src/pages/ExportCSV.jsx
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { getDocs, collection } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

export default function ExportCSV() {
  const navigate = useNavigate();
  const [dataset, setDataset] = useState('users');
  const [users, setUsers] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      if (dataset === 'users') {
        const snap = await getDocs(collection(db, 'users'));
        setUsers(snap.docs.map(doc => doc.data()));
      } else {
        const snap = await getDocs(collection(db, 'bookings'));
        setBookings(snap.docs.map(doc => doc.data()));
      }
    };
    fetchData();
  }, [dataset]);

  const formatDate = (ts) =>
    ts?.seconds ? new Date(ts.seconds * 1000).toLocaleDateString() : '';

  const exportToCSV = () => {
    const data = dataset === 'users' ? users : bookings.filter(b => {
      const start = b.startDate?.seconds ? new Date(b.startDate.seconds * 1000) : null;
      const from = startDate ? new Date(startDate) : null;
      const to = endDate ? new Date(endDate) : null;
      return (!from || start >= from) && (!to || start <= to);
    });

    const headers = dataset === 'users'
      ? ['Name', 'Email', 'Tier', 'City']
      : ['Renter', 'Listing', 'Start', 'End', 'Total', 'Status'];

    const rows = dataset === 'users'
      ? data.map(u => [u.name || '', u.email || '', u.tier || 'basic', u.city || ''])
      : data.map(b => [
          b.bookedByName || b.renterId,
          b.listingTitle,
          formatDate(b.startDate),
          formatDate(b.endDate),
          b.totalCost,
          b.status
        ]);

    const csv = [headers, ...rows].map(r => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${dataset}_export.csv`;
    a.click();
  };

  return (
    <div style={styles.container}>
      <button onClick={() => navigate('/dashboard')} style={styles.backButton}>
        ← Back to Dashboard
      </button>
      <h2 style={styles.title}>📄 Export CSV</h2>

      <div style={styles.filters}>
        <label>
          Dataset:
          <select value={dataset} onChange={(e) => setDataset(e.target.value)} style={styles.select}>
            <option value="users">Users</option>
            <option value="bookings">Bookings</option>
          </select>
        </label>

        {dataset === 'bookings' && (
          <>
            <label style={styles.label}>From:
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={styles.input} />
            </label>
            <label style={styles.label}>To:
              <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} style={styles.input} />
            </label>
          </>
        )}

        <button onClick={exportToCSV} style={styles.exportButton}>Export CSV</button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: '2rem',
    fontFamily: 'system-ui, sans-serif',
    backgroundColor: '#f9f9f9',
    minHeight: '100vh',
  },
  backButton: {
    marginBottom: '0.5rem',
    backgroundColor: '#eeeeee',
    border: '1px solid #ccc',
    padding: '0.4rem 0.8rem',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 500,
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#065f46',
    marginBottom: '1.5rem',
  },
  filters: {
    backgroundColor: '#ffffff',
    padding: '1rem',
    borderRadius: '8px',
    maxWidth: '640px',
    marginTop: '1rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
  },
  label: {
    display: 'inline-block',
    marginRight: '1rem',
    marginTop: '1rem'
  },
  select: {
    marginLeft: '0.5rem',
    padding: '0.3rem',
    fontSize: '1rem',
  },
  input: {
    marginLeft: '0.5rem',
    padding: '0.3rem',
    fontSize: '1rem',
  },
  exportButton: {
    marginLeft: '1rem',
    padding: '0.5rem 1rem',
    backgroundColor: '#065f46',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.9rem'
  },
};
